import type { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';
import type { Mutators as ArrayMutators } from 'final-form-arrays';
import { Form, FormProps } from 'react-final-form';

import { setField, setFieldTouched, clearField, getMutator } from '~/util/formMutators';

type ValueOf<T> = T[keyof T];

type SetFieldMutator<T> = (...args: [field: keyof T, value: ValueOf<T>]) => void;

type FormMutators<T> = ArrayMutators & {
  setField: SetFieldMutator<T>;
  clear: (field: keyof T) => void;
  setFieldTouched: (field: keyof T, touched: boolean) => void;

  // this is what final form specifies for the mutators
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [mutator: string]: (...args: any[]) => any;
};

export type FormWithMutators<T> = FormApi<T> & {
  mutators: FormMutators<T>;
};

export const MutatingForm = <FormValues,>(
  props: FormProps<FormValues, Partial<FormValues>>
): React.ReactElement => {
  return (
    <Form<FormValues, Partial<FormValues>>
      mutators={{
        ...arrayMutators,
        setField: getMutator<FormValues, Partial<FormValues>>(setField),
        setFieldTouched,
        clear: getMutator<FormValues, Partial<FormValues>>(clearField),
      }}
      {...props}
    />
  );
};
